import React, { Component } from 'react';
import {
    Row, Col, Radio, Table, Input,
} from 'antd';
import { connect } from 'react-redux';
import axios from 'axios';

import RefillList from './RefillsList';
import { SET_REFILLS } from '../../ActionTypes/ActionTypes';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { Search } = Input;

class SearchTab extends Component {
    state = {
        fetching: false,
        selectSearchOption: 'name',
        searchValue: '',
        orders: [],
    };

    componentDidMount = () => {
        const { setRefills } = this.props;
        setRefills([]);
    }

    onSearchChange = (event) => {
        this.setState({
            selectSearchOption: event.target.value,
        });
    }

    changeSubmitValue = (event) => {
        this.setState({ searchValue: event.target.value });
    }

    onSearchSubmit = (value) => {
        const { selectSearchOption } = this.state;

        this.setState({ fetching: true });
        if (selectSearchOption === 'name') {
            axios({
                method: 'get',
                url: `orders/search_by_name.json?name=${value}`,
                headers: { Authorization: sessionStorage.getItem('jwtToken') },
            })
                .then((response) => {
                    this.setState({
                        orders: response.data,
                        fetching: false,
                    });
                });
        } else if (selectSearchOption === 'mobile') {
            axios({
                method: 'get',
                url: `orders/search_by_mobile.json?mobile_number=${value}`,
                headers: { Authorization: sessionStorage.getItem('jwtToken') },
            })
                .then((response) => {
                    this.setState({
                        orders: response.data,
                        fetching: false,
                    });
                });
        }
    }

    handleUserClick = (id) => {
        // console.log(id);
        const { setRefills } = this.props;

        axios({
            method: 'get',
            url: `/carefills/carefill_by_order_id.json?order_id=${id}`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                setRefills(response.data.carefills);
                // console.log(response.data.carefills);
                this.setState({
                    orders: [],
                    fetching: false,
                });
            });
    }

    render() {
        const {
            selectSearchOption, searchValue, orders, fetching,
        } = this.state;

        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            fixed: 'left',
            width: 75,
            align: 'center',
        }, {
            title: 'Name',
            fixed: 'left',
            width: 200,
            render: record => (
                <span onClick={() => this.handleUserClick(record.id)} role="button" style={{ cursor: 'pointer', color: 'blue' }}>
                    {record.user.first_name} {record.user.last_name}
                    {/* {
                        record.user.is_vip === false
                            ? <a href="">{record.user.first_name} {record.user.last_name}</a>
                            : (
                                <span>
                                    <a href="">{record.user.first_name} {record.user.last_name}</a> <Badge count="VIP" style={{ backgroundColor: '#52c41a' }} />
                                </span>
                            )
                    }
                    {
                        record.p_prescriptions == null ? '' : record.p_prescriptions.length > 0
                            ? <span> (Rx)</span>
                            : ''
                    } */}
                </span>
            ),
        }, {
            title: 'Mobile Number',
            dataIndex: 'user',
            render: user => (user.mobile_number == null ? 'Not Provided' : `${user.mobile_number}`),
        }, {
            title: 'Location',
            render: record => record.partner_location.name,
        }, {
            title: 'Start Date',
            render: record => (record.carefill_count === 0 ? 'Yet to start' : record.start_date),
        },
        ];

        return (
            <div style={{ textAlign: 'center' }}>
                <Row type="flex" justify="center">
                    <Col>
                        <RadioGroup onChange={this.onSearchChange} value={selectSearchOption}>
                            <RadioButton value="name">Name</RadioButton>
                            <RadioButton value="mobile">Mobile</RadioButton>
                        </RadioGroup>
                    </Col>

                    <Col style={{ marginLeft: '10px' }}>
                        <Search
                            className="m-auto"
                            enterButton
                            value={searchValue}
                            onChange={event => this.changeSubmitValue(event)}
                            placeholder="Name/Mobile"
                            onSearch={value => this.onSearchSubmit(value)}
                            style={{ width: 300 }}
                        />
                    </Col>
                </Row>

                <div style={{ height: 40 }} />

                <Table
                    dataSource={orders}
                    columns={columns}
                    loading={fetching}
                    bordered
                    pagination={false}
                    size="small"
                    rowKey="id"
                />

                <div style={{ marginTop: 50 }} />

                <RefillList />

            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
});

export default connect(null, mapDispatchToProps)(SearchTab);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/SearchTab.js